/*
@license
  Be Yours by roartheme (https://roartheme.co)
  Access unminified JS in assets/global.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/beyours/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
function isStorageSupported(e) {
    if (window.self !== window.top) return !1;
    const t = "beyours:test";
    let i;
    "session" === e && (i = window.sessionStorage), "local" === e && (i = window.localStorage);
    try {
        return i.setItem(t, "1"), i.removeItem(t), !0;
    } catch (e) {
        return !1;
    }
}
function checkScrollbar() {
    const e = document.body.getBoundingClientRect();
    return Math.round(e.left + e.right) < window.innerWidth;
}
function setScrollbarWidth() {
    if (checkScrollbar()) {
        const e = document.createElement("span");
        (e.className = "modal-scrollbar-measure"), document.body.appendChild(e);
        const t = e.getBoundingClientRect().width - e.clientWidth;
        document.body.removeChild(e), document.documentElement.style.setProperty("--scrollbar-width", `${t}px`);
    }
}
function setHeaderBottomPosition() {
    const e = document.querySelector(".shopify-section-header");
    e && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(e.getBoundingClientRect().bottom)}px`);
}
function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
(window.theme = window.theme || {}),
    (theme.config = {
        mqlSmall: !1,
        mediaQuerySmall: "screen and (max-width: 749px)",
        isTouch: !!("ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch) || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints),
        rtl: "rtl" === document.documentElement.getAttribute("dir"),
    }),
    console && console.log && console.log(theme.settings.themeName + " theme (" + theme.settings.themeVersion + ") by RoarTheme | Learn more at https://roartheme.co"),
    (theme.Currency = {
        formatMoney: function (e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            let i = "";
            const s = /\{\{\s*(\w+)\s*\}\}/,
                n = t || "${{amount}}";
            function o(e, t, i, s) {
                if (((i = i || ","), (s = s || "."), isNaN(e) || null === e)) return 0;
                const n = (e = (e / 100).toFixed(t)).split(".");
                return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? s + n[1] : "");
            }
            switch (n.match(s)[1]) {
                case "amount":
                    i = o(e, 2);
                    break;
                case "amount_no_decimals":
                    i = o(e, 0);
                    break;
                case "amount_with_comma_separator":
                    i = o(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    i = o(e, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    i = o(e, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    i = o(e, 2, "'");
            }
            return n.replace(s, i);
        },
        getBaseUnit: function (e) {
            if (e && e.unit_price_measurement && e.unit_price_measurement.reference_value)
                return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
        },
    }),
    (theme.initWhenVisible = function (e) {
        const t = e.threshold ? e.threshold : 0;
        new IntersectionObserver(
            (t, i) => {
                t.forEach((t) => {
                    t.isIntersecting && "function" == typeof e.callback && (e.callback(), i.unobserve(t.target));
                });
            },
            { rootMargin: `0px 0px ${t}px 0px` }
        ).observe(e.element);
    }),
    (function () {
        const e = window.matchMedia(theme.config.mediaQuerySmall);
        function t() {
            window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`), setHeaderBottomPosition();
        }
        if (
            ((theme.config.mqlSmall = e.matches),
            (e.onchange = (e) => {
                e.matches ? ((theme.config.mqlSmall = !0), document.dispatchEvent(new CustomEvent("matchSmall"))) : ((theme.config.mqlSmall = !1), document.dispatchEvent(new CustomEvent("unmatchSmall")));
            }),
            window.addEventListener("beforeunload", () => {
                document.body.classList.add("unloading");
            }),
            window.addEventListener("DOMContentLoaded", () => {
                document.body.classList.add("loaded"), document.dispatchEvent(new CustomEvent("page:loaded"));
            }),
            window.addEventListener("pageshow", (e) => {
                e.persisted && document.body.classList.remove("unloading");
            }),
            window.addEventListener("resize", t),
            window.addEventListener("DOMContentLoaded", t),
            null !== document.body.getAttribute("data-page-rendering"))
        ) {
            const e = new IntersectionObserver(
                (e, t) => {
                    e.forEach((e) => {
                        const t = e.target;
                        0 != e.intersectionRatio && (t.markedVisible || (t.attributeStyleMap && t.attributeStyleMap.set("content-visibility", "visible"), (t.markedVisible = !0)));
                    });
                },
                { rootMargin: "50px 0px 100px 0px" }
            );
            document.querySelectorAll(".shopify-section + .shopify-section").forEach((t) => {
                e.observe(t);
            });
        }
    })(),
    (function () {
        var e,
            t = !1;
        document.body.addEventListener("touchstart", function (i) {
            if (!i.target.closest(".flickity-slider")) return (t = !1);
            (t = !0), (e = { x: i.touches[0].pageX, y: i.touches[0].pageY });
        }),
            document.body.addEventListener(
                "touchmove",
                function (i) {
                    if (t && i.cancelable) {
                        var s = { x: i.touches[0].pageX - e.x, y: i.touches[0].pageY - e.y };
                        Math.abs(s.x) > Flickity.defaults.dragThreshold && i.preventDefault();
                    }
                },
                { passive: !1 }
            );
    })();
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        s = i[0],
        n = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== n && t.target !== s) || document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === (t.code ? t.code.toUpperCase() : t.key.toUpperCase()) && (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()), (t.target !== e && t.target !== s) || !t.shiftKey || (t.preventDefault(), n.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t && t.focus(),
        "INPUT" === t.tagName && ["search", "text", "email", "url"].includes(t.type) && t.value && t.setSelectionRange(0, t.value.length);
}
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
    const e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let t = null,
        i = null;
    window.addEventListener("keydown", (t) => {
        e.includes(t.code.toUpperCase()) && (i = !1);
    }),
        window.addEventListener("mousedown", (e) => {
            i = !0;
        }),
        window.addEventListener(
            "focus",
            () => {
                t && t.classList.remove("focused"), i || ((t = document.activeElement), t.classList.add("focused"));
            },
            !0
        );
}
function pauseAllMedia() {
    document.querySelectorAll('video-section[data-type="youtube"]:not([data-video-hero]) iframe').forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll('video-section[data-type="vimeo"]:not([data-video-hero]) iframe').forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => {
            e.closest("[data-video-hero]") || e.pause();
        }),
        document.querySelectorAll("product-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus();
}
function onKeyUpEscape(e) {
    if ("ESCAPE" !== (e.code ? e.code.toUpperCase() : e.key.toUpperCase())) return;
    const t = e.target.closest("details[open]");
    if (!t) return;
    const i = t.querySelector("summary");
    t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
function filterShopifyEvent(e, t, i) {
    let s = !1;
    e.type.includes("shopify:section") ? t.hasAttribute("data-section-id") && t.getAttribute("data-section-id") === e.detail.sectionId && (s = !0) : e.type.includes("shopify:block") && e.target === t && (s = !0), s && i(e);
}
function debounce(e, t) {
    let i;
    return (...s) => {
        clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
    };
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
const serializeForm = (e) => {
    const t = {},
        i = new FormData(e);
    for (const e of i.keys()) {
        const s = /(?:^(properties\[))(.*?)(?:\]$)/;
        s.test(e) ? ((t.properties = t.properties || {}), (t.properties[s.exec(e)[2]] = i.get(e))) : (t[e] = i.get(e));
    }
    return JSON.stringify(t);
};
void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var i = 0, s = e.options.length; i < s; i++) {
            var n = e.options[i];
            if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
        }
    }),
    (Shopify.addListener = function (e, t, i) {
        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
    }),
    (Shopify.postLink = function (e, t) {
        const i = (t = t || {}).method || "post",
            s = t.parameters || {},
            n = document.createElement("form");
        n.setAttribute("method", i), n.setAttribute("action", e);
        for (const e in s) {
            const t = document.createElement("input");
            t.setAttribute("type", "hidden"), t.setAttribute("name", e), t.setAttribute("value", s[e]), n.appendChild(t);
        }
        document.body.appendChild(n), n.submit(), document.body.removeChild(n);
    }),
    (Shopify.postLink2 = function (e, t) {
        const i = (t = t || {}).method || "post",
            s = t.parameters || {},
            n = document.createElement("form");
        n.setAttribute("method", i), n.setAttribute("action", e);
        for (const e in s)
            for (const t in s[e])
                for (const i in s[e][t]) {
                    const o = document.createElement("input");
                    o.setAttribute("type", "hidden"), o.setAttribute("name", `${e}[${t}][${i}]`), o.setAttribute("value", s[e][t][i]), n.appendChild(o);
                }
        document.body.appendChild(n), n.submit(), document.body.removeChild(n);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, i) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(i.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                i = JSON.parse(t);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var s = 0; s < i.length; s++) {
                    var n;
                    ((n = document.createElement("option")).value = i[s][0]), (n.innerHTML = i[s][1]), this.provinceEl.appendChild(n);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            var i = 0;
            for (t.length; i < t.length; i++) {
                var s = document.createElement("option");
                (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
            }
        },
    });
class QuantityInput extends HTMLElement {
    constructor() {
        super(), this.init();
    }
    init() {
        (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this))),
            this.input.addEventListener("focus", this.onInputFocus.bind(this));
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = this.input.value;
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
    onInputFocus() {
        this.input.select();
    }
}
customElements.define("quantity-input", QuantityInput);
class DrawerCloseButton extends HTMLElement {
    constructor() {
        super(), this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("drawer:force-close", { bubbles: !0, cancelable: !0, composed: !0 })));
    }
}
customElements.define("drawer-close-button", DrawerCloseButton);
class MenuDrawer extends HTMLElement {
    constructor() {
        super(),
            (this.classes = { open: "menu-drawer--open", opening: "menu-drawer--opening", closing: "menu-drawer--closing" }),
            (this.mainDetailsToggle = this.querySelector("details")),
            this.addEventListener("keyup", this.onKeyUp.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.bindEvents();
    }
    setClasses(e) {
        this.classes = e;
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((e) => e.addEventListener("click", this.onSummaryClick.bind(this))),
            this.querySelectorAll("button[data-close]").forEach((e) => e.addEventListener("click", this.onCloseButtonClick.bind(this))),
            this.addEventListener("drawer:force-close", (e) => {
                e.stopPropagation(), this.closeMenuDrawer(e);
            });
    }
    onKeyUp(e) {
        if ("ESCAPE" !== (e.code ? e.code.toUpperCase() : e.key.toUpperCase())) return;
        const t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t));
    }
    onSummaryClick(e) {
        const t = e.currentTarget,
            i = t.parentNode,
            s = i.hasAttribute("open"),
            n = window.matchMedia("(prefers-reduced-motion: reduce)");
        function o() {
            trapFocus(t.nextElementSibling, i.querySelector("button")), t.nextElementSibling.removeEventListener("transitionend", o);
        }
        i === this.mainDetailsToggle
            ? (s && e.preventDefault(), s ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t))
            : setTimeout(() => {
                  i.classList.add("menu-opening"), t.setAttribute("aria-expanded", !0), !n || n.matches ? o() : t.nextElementSibling.addEventListener("transitionend", o);
              }, 100);
    }
    openMenuDrawer(e = !1) {
        setScrollbarWidth(),
            setHeaderBottomPosition(),
            e && (e.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, e)),
            setTimeout(() => {
                (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)), document.body.addEventListener("click", this.onBodyClickEvent);
            }),
            document.body.classList.add(this.classes.opening),
            this.openAnimation(),
            setTimeout(() => {
                this.mainDetailsToggle.setAttribute("open", ""),
                    setTimeout(() => {
                        this.mainDetailsToggle.classList.add("menu-opening");
                    }, 10);
            });
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e &&
            (this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
                e.removeAttribute("open"), e.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.classList.add("menu-closing"),
            removeTrapFocus(t),
            document.body.removeEventListener("click", this.onBodyClickEvent),
            document.body.classList.remove(this.classes.open),
            document.body.classList.add(this.classes.closing),
            this.closeAnimation(this.mainDetailsToggle),
            this.dispatchEvent(new CustomEvent("close")),
            document.dispatchEvent(new CustomEvent("menudrawer:close")));
    }
    onFocusOut() {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(e) {
        const t = e.currentTarget;
        if (t.classList.contains("noclose")) return;
        const i = t.closest("details");
        this.closeSubmenu(i);
    }
    closeSubmenu(e) {
        e.classList.remove("menu-opening"), e.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(), this.closeAnimation(e);
    }
    openAnimation() {
        let e;
        const t = (i) => {
            void 0 === e && (e = i);
            i - e < 400 ? window.requestAnimationFrame(t) : (document.body.classList.remove(this.classes.opening), document.body.classList.add(this.classes.open));
        };
        window.requestAnimationFrame(t);
    }
    closeAnimation(e) {
        let t;
        const i = (s) => {
            void 0 === t && (t = s);
            s - t < 400
                ? window.requestAnimationFrame(i)
                : (e === this.mainDetailsToggle && (document.body.classList.remove(this.classes.closing), e.classList.remove("menu-closing")),
                  e.removeAttribute("open"),
                  e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
        };
        window.requestAnimationFrame(i);
    }
    onBodyClick(e) {
        this.contains(e.target) || this.closeMenuDrawer(e);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class CartDrawer extends MenuDrawer {
    constructor() {
        super(), this.setClasses({ open: "mini-cart--open", opening: "mini-cart--opening", closing: "mini-cart--closing" });
    }
}
customElements.define("cart-drawer", CartDrawer);
class FacetDrawer extends MenuDrawer {
    constructor() {
        super(),
            "true" == this.dataset.desktop
                ? this.setClasses({ open: "facet-horizontal--open", opening: "facet-horizontal--opening", closing: "facet-horizontal--closing" })
                : this.setClasses({ open: "facet-drawer--open", opening: "facet-drawer--opening", closing: "facet-drawer--closing" });
    }
}
customElements.define("facet-drawer", FacetDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super(), this.setClasses({ open: "menu-mobile--open", opening: "menu-mobile--opening", closing: "menu-mobile--closing" });
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this)),
            this.addEventListener("keyup", (e) => {
                "ESCAPE" === (e.code ? e.code.toUpperCase() : e.key.toUpperCase()) && this.hide();
            }),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", (e) => {
                      "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide();
                  })
                : this.addEventListener("click", (e) => {
                      "MODAL-DIALOG" === e.target.nodeName && this.hide();
                  });
    }
    show(e) {
        setScrollbarWidth(), (this.openedBy = e);
        const t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super(),
            (this.button = this.querySelector("button")),
            this.button &&
                this.button.addEventListener("click", () => {
                    const e = document.querySelector(this.getAttribute("data-modal"));
                    e && e.show(this.button);
                });
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super(), (this.poster = this.querySelector('[id^="Deferred-Poster-"]')), this.poster && this.poster.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent(e = !0) {
        if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
            const t = document.createElement("div");
            if ((t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), t.querySelector("video-section"))) {
                const i = this.appendChild(t);
                e && i.focus(), "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play();
            } else {
                this.setAttribute("loaded", !0);
                const i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
                e && i.focus(), "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play();
            }
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        super(),
            (this.slider = this.querySelector('[id^="Slider-"]')),
            (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
            (this.enableSliderLooping = !1),
            (this.currentPageElement = this.querySelector(".slider-counter--current")),
            (this.pageTotalElement = this.querySelector(".slider-counter--total")),
            (this.prevButton = this.querySelector('button[name="previous"]')),
            (this.nextButton = this.querySelector('button[name="next"]')),
            this.slider && this.nextButton && theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 200 });
    }
    init() {
        new ResizeObserver(() => this.initPages()).observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    initPages() {
        (this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
            this.sliderItemsToShow.length < 2 ||
                ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
                (this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset)),
                (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
                this.update());
    }
    resetPages() {
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
    }
    update() {
        const e = this.currentPage;
        if (
            ((this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
            this.currentPageElement && this.pageTotalElement && ((this.currentPageElement.textContent = this.currentPage), (this.pageTotalElement.textContent = this.totalPages)),
            this.currentPage != e && this.dispatchEvent(new CustomEvent("slideChanged", { detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] } })),
            1 === this.currentPage && this.currentPage === this.totalPages ? this.classList.add("slider--no-buttons") : this.classList.remove("slider--no-buttons"),
            this.enableSliderLooping)
        )
            return;
        const t = 1 === this.currentPage,
            i = this.currentPage === this.sliderItemsToShow.length;
        t || this.isSlideVisible(this.sliderItemsToShow[0]) ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"),
            i || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled");
    }
    isSlideVisible(e, t = 0) {
        const i = this.slider.clientWidth + this.slider.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = e.currentTarget.dataset.step || 1;
        (this.slideScrollPosition = "next" === e.currentTarget.name ? this.slider.scrollLeft + t * this.sliderItemOffset : this.slider.scrollLeft - t * this.sliderItemOffset), this.slider.scrollTo({ left: this.slideScrollPosition });
    }
}
customElements.define("slider-component", SliderComponent);
class ThumbnailSlider extends SliderComponent {
    constructor() {
        super();
    }
    init() {
        super.init();
        const e = this.querySelectorAll(".thumbnail-list_item--variant:not(.is-active)");
        if (((this.slider.dataset.mediaCount = this.sliderItems.length - e.length), this.querySelector("[data-gang-option]"))) {
            const e = this.querySelectorAll("[data-gang-option]:not(.gang__active)");
            this.slider.dataset.mediaCount = this.sliderItems.length - e.length;
        }
        this.slider.dataset.mediaCount < 2 && this.classList.add("hidden");
    }
}
customElements.define("thumbnail-slider", ThumbnailSlider);
class QuoteSlider extends SliderComponent {
    constructor() {
        super();
    }
    update() {
        if ((super.update(), this.currentPageElement && this.pageTotalElement)) {
            this.sliderItems.forEach((e) => {
                e.removeAttribute("aria-current");
            });
            this.sliderItemsToShow[this.currentPage - 1].setAttribute("aria-current", !0);
        }
    }
}
customElements.define("quote-slider", QuoteSlider);
class ProductGallery extends SliderComponent {
    constructor() {
        super();
    }
    init() {
        super.init();
        const e = this.querySelector(".slider-buttons");
        if (
            (e && this.querySelector("[data-gang-option]") && (this.querySelectorAll(".product__media-item.gang__active").length < 2 ? e.classList.add("hidden") : e.classList.remove("hidden")),
            (this.cursor = this.querySelector(".gallery-cursor")),
            !this.cursor)
        )
            return;
        const t = this.querySelectorAll(".product__modal-opener--image");
        t.forEach((e) => e.addEventListener("mousemove", this.onMoveHandler.bind(this))),
            t.forEach((e) => e.addEventListener("mouseenter", this.onEnterHandler.bind(this))),
            t.forEach((e) => e.addEventListener("mouseleave", this.onLeaveHandler.bind(this)));
    }
    onMoveHandler(e) {
        (this.cursor.style.left = e.clientX - 32 + "px"), (this.cursor.style.top = e.clientY - 32 + "px");
    }
    onEnterHandler() {
        this.cursor.classList.add("show");
    }
    onLeaveHandler() {
        this.cursor.classList.remove("show");
    }
    update() {
        if ((super.update(), this.currentPageElement && this.pageTotalElement)) {
            const e = this.sliderItemsToShow[this.currentPage - 1];
            e && this.slider.style.setProperty("--force-image-ratio-percent", e.querySelector(".media").style.getPropertyValue("--image-ratio-percent"));
        }
    }
    goToFirstSlide() {
        this.slider.scrollTo({ left: 0 });
    }
}
customElements.define("product-gallery", ProductGallery);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange), this.updateOptions(), this.updateMasterId(), this.setAvailability();
    }
    onVariantChange(e) {
        this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(!0, "", !1),
            this.updatePickupAvailability(),
            this.removeErrorMessage(),
            this.validateGang(),
            this.currentVariant
                ? (this.gangOption ? this.updateGangMedia() : this.updateMedia(),
                  this.updateURL(),
                  this.updateVariantInput(),
                  this.renderProductInfo(),
                  this.setAvailability(),
                  document.dispatchEvent(new CustomEvent("variant:change", { detail: { variant: this.currentVariant } })))
                : (this.toggleAddButton(!0, "", !0), this.setUnavailable(), this.setAvailabilityInUnavailable()),
            this.handleStickyCart(e.target);
    }
    handleStickyCart(e) {
        if (!document.getElementById(`sticky-cart-${this.dataset.section}`)) return;
        const t = e.getAttribute("name");
        if (
            (document.querySelectorAll(`variant-radios[data-section="${this.dataset.section}"] [name="${t}"], variant-selects[data-section="${this.dataset.section}"] [name="${t}"]`).forEach((t) => {
                "INPUT" === t.tagName ? (t.checked = t.value === e.value) : (t.value = e.value);
            }),
            !this.currentVariant)
        )
            return;
        if (!this.currentVariant.featured_media) return;
        const i = document.querySelector(".sticky-cart__content-image img");
        i &&
            ((i.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`),
            (i.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`),
            (i.width = 70),
            (i.height = Math.ceil(70 / this.currentVariant.featured_media.preview_image.aspect_ratio)));
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (e) => e.value);
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1));
    }
    validateGang() {
        const e = document.querySelector(`#shopify-section-${this.dataset.section} [data-gang-option], quick-view-drawer details[open] [data-gang-option]`);
        e && (this.gangOption = e.dataset.gangOption);
    }
    updateGangMedia() {
        if (!this.gangOption) return;
        const e = this.querySelector('.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]');
        if ((e ? (this.gangIndex = e.dataset.optionIndex) : (this.gangOption = null), !this.currentVariant)) return;
        const t = document.getElementById(`MediaGallery-${this.dataset.section}`),
            i = this.getSlug(this.currentVariant[this.gangIndex]);
        if (this.currentGangValue !== i) {
            document.querySelectorAll(`#shopify-section-${this.dataset.section} [data-gang-connect], quick-view-drawer details[open] [data-gang-connect]`).forEach(function (e) {
                e.classList.remove("gang__active");
            }),
                (this.currentGangValue = i);
            var s = this.gangOption + "_" + i;
            const e = document.querySelectorAll(`#shopify-section-${this.dataset.section} [data-gang-connect="${s}"], quick-view-drawer details[open] [data-gang-connect="${s}"]`);
            if (!e.length) return;
            Array.from(e)
                .reverse()
                .forEach(function (e) {
                    e.classList.add("gang__active");
                    let t = e.parentElement;
                    t.firstChild != e && (t.prepend(e), t.classList.add("product__media-no-animate"));
                });
            const n = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);
            if (n) {
                const e = n.querySelectorAll(".thumbnail-list__item:not(.gang__active)");
                (n.slider.dataset.mediaCount = n.sliderItems.length - e.length), n.slider.dataset.mediaCount < 2 ? n.classList.add("hidden") : n.classList.remove("hidden"), n.resetPages();
            }
            if (!t) {
                const e = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery, quick-view-drawer details[open] product-gallery`);
                e && (e.resetPages(), e.goToFirstSlide());
            }
            const o = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .slider-buttons, quick-view-drawer details[open] product-gallery .slider-buttons`);
            o &&
                (document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).length < 2
                    ? o.classList.add("hidden")
                    : o.classList.remove("hidden"));
        }
        if (!this.currentVariant.featured_media)
            return void (
                document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active.is-active`)
                    .length ||
                document
                    .querySelector(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`)
                    .classList.add("is-active")
            );
        if (t) {
            const e = void 0 === this.dataset.noScroll;
            t.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0, e);
        }
        const n = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (n) {
            const e = n.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
            n.prepend(e);
        }
        const o = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
        if (o) {
            const e = o.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
            o.prepend(e);
        }
    }
    CJKDetect(e) {
        return e.search("[가-힣]") >= 0 ? "ko" : e.search("[぀-ヿ]") >= 0 ? "ja" : e.search("[一-鿿]") >= 0 ? "zh" : "none";
    }
    getSlug(e) {
        return "none" != this.CJKDetect(e)
            ? e
            : e
                  .toString()
                  .replace("ı", "i")
                  .normalize("NFD")
                  .replace("-", " ")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
                  .trim()
                  .replace(/[^a-z0-9 ]/g, "")
                  .replace(/\s+/g, "-");
    }
    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        const e = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!e) return;
        const t = e.parentElement;
        if (t.firstChild == e) return;
        t.prepend(e), t.classList.add("product__media-no-animate"), t.parentElement.goToFirstSlide();
        const i = document.getElementById(`MediaGallery-${this.dataset.section}`);
        if (i) {
            const e = void 0 === this.dataset.noScroll;
            i.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0, e);
        }
        const s = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (s) {
            const e = s.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
            s.prepend(e);
        }
        const n = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
        if (n) {
            const e = n.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
            n.prepend(e);
        }
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}--alt`).forEach((e) => {
            const t = e.querySelector('input[name="id"]');
            (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
    }
    removeErrorMessage() {
        const e = this.closest("section");
        if (!e) return;
        const t = e.querySelector("product-form");
        t && t.handleErrorMessage();
    }
    renderProductInfo() {
        const e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((e) => e.text())
            .then((t) => {
                this.updateSKU(t),
                    this.updatePrice(t),
                    this.updatePriceAlt(t),
                    this.updateColorName(t),
                    this.updateInventoryStatus(t),
                    this.currentVariant && this.toggleAddButton(!this.currentVariant.available, theme.variantStrings.soldOut),
                    this.updateCustomLiquid(t),
                    document.dispatchEvent(new CustomEvent("productInfo:loaded")),
                    publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: e, variant: this.currentVariant } });
            })
            .catch((e) => {
                console.error(e);
            });
    }
    updateSKU(e) {
        const t = `sku-${this.dataset.section}`,
            i = new DOMParser().parseFromString(e, "text/html"),
            s = document.getElementById(t),
            n = i.getElementById(t);
        n && s && (s.innerHTML = n.innerHTML), s && s.classList.remove("visibility-hidden");
    }
    updateCustomLiquid(e) {
        const t = new DOMParser().parseFromString(e, "text/html"),
            i = document.querySelectorAll(`.custom__liquid-${this.dataset.section}`),
            s = t.querySelectorAll(`.custom__liquid-${this.dataset.section}`);
        for (let e = 0, t = i.length; e < t; e++) i[e].innerHTML = s[e].innerHTML;
    }
    updatePrice(e) {
        const t = `price-${this.dataset.section}`,
            i = new DOMParser().parseFromString(e, "text/html"),
            s = document.getElementById(t),
            n = i.getElementById(t);
        n && s && (s.innerHTML = n.innerHTML), s && s.classList.remove("visibility-hidden");
    }
    updatePriceAlt(e) {
        const t = `price-${this.dataset.section}--alt`,
            i = new DOMParser().parseFromString(e, "text/html"),
            s = document.getElementById(t),
            n = i.getElementById(t);
        n && s && (s.innerHTML = n.innerHTML), s && s.classList.remove("visibility-hidden");
    }
    updateColorName(e) {
        const t = new DOMParser().parseFromString(e, "text/html");
        for (let e = 1; e <= 3; e++) {
            const i = e > 1 ? `color-${this.dataset.section}-${e}` : `color-${this.dataset.section}`,
                s = document.getElementById(i),
                n = t.getElementById(i);
            n && s && (s.innerHTML = n.innerHTML), s && s.classList.remove("visibility-hidden");
        }
    }
    updateInventoryStatus(e) {
        const t = `inventory-${this.dataset.section}`,
            i = new DOMParser().parseFromString(e, "text/html"),
            s = document.getElementById(t),
            n = i.getElementById(t);
        n && s && (s.innerHTML = n.innerHTML), s && s.classList.remove("visibility-hidden");
    }
    toggleAddButton(e = !0, t, i = !0) {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`).forEach((i) => {
            const s = i.querySelector('[name="add"]');
            s && (e ? (s.setAttribute("disabled", !0), t && (s.textContent = t)) : (s.removeAttribute("disabled"), (s.textContent = "true" === s.dataset.preOrder ? theme.variantStrings.preOrder : theme.variantStrings.addToCart)));
        });
    }
    setUnavailable() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`).forEach((e) => {
            const t = e.querySelector('[name="add"]');
            if (!t) return;
            t.textContent = theme.variantStrings.unavailable;
            const i = document.getElementById(`price-${this.dataset.section}`);
            i && i.classList.add("visibility-hidden");
            const s = document.getElementById(`price-${this.dataset.section}--alt`);
            s && s.classList.add("visibility-hidden");
            const n = document.getElementById(`inventory-${this.dataset.section}`);
            n && n.classList.add("visibility-hidden");
        });
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
    setAvailability() {
        if (!this.currentVariant) return;
        this.querySelectorAll(".variant-input-wrapper").forEach((e) => {
            this.disableVariantGroup(e);
        });
        const e = this.currentVariant.options.map((e, t) => ({ value: e, index: `option${t + 1}` })),
            t = this.createAvailableOptionsTree(this.variantData, e, this.currentVariant);
        for (var [i, s] of Object.entries(t)) this.manageOptionState(i, s);
    }
    setAvailabilityInUnavailable() {
        this.querySelectorAll(".variant-input-wrapper").forEach((e) => {
            this.disableVariantGroup(e);
        });
        const e = this.options.map((e, t) => ({ value: e, index: `option${t + 1}` })),
            t = this.createAvailableOptionsTree(this.variantData, e, this.currentVariant);
        for (var [i, s] of Object.entries(t)) this.manageOptionState(i, s);
    }
    enableVariantOption(e, t) {
        const i = t.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
        e.querySelector('option[value="' + i + '"]').disabled = !1;
    }
    disableVariantGroup(e) {
        e.querySelectorAll("option").forEach((e) => {
            e.disabled = !0;
        });
    }
    manageOptionState(e, t) {
        const i = this.querySelector('.variant-input-wrapper[data-option-index="' + e + '"]');
        t.forEach((e) => {
            this.enableVariantOption(i, e);
        });
    }
    createAvailableOptionsTree(e, t) {
        return e.reduce(
            (e, i) => (
                Object.keys(e).forEach((s) => {
                    if (null === i[s]) return;
                    let n = e[s].find((e) => e.value === i[s]);
                    void 0 === n && ((n = { value: i[s], soldOut: !0 }), e[s].push(n));
                    const o = t.find(({ value: e, index: t }) => "option1" === t),
                        a = t.find(({ value: e, index: t }) => "option2" === t);
                    switch (s) {
                        case "option1":
                            n.soldOut = (!n.soldOut || !i.available) && n.soldOut;
                            break;
                        case "option2":
                            o && i.option1 === o.value && (n.soldOut = (!n.soldOut || !i.available) && n.soldOut);
                        case "option3":
                            o && i.option1 === o.value && a && i.option2 === a.value && (n.soldOut = (!n.soldOut || !i.available) && n.soldOut);
                    }
                }),
                e
            ),
            { option1: [], option2: [], option3: [] }
        );
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    updateOptions() {
        const e = Array.from(this.querySelectorAll("fieldset"));
        this.options = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
    }
    enableVariantOption(e, t) {
        const i = t.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1"),
            s = e.querySelector('input[data-option-value="' + i + '"]');
        s.removeAttribute("disabled"),
            s.removeAttribute("data-crossout"),
            t.soldOut && this.hasAttribute("data-swatch-cross") && (this.hasAttribute("data-swatch-oos-click") ? s.setAttribute("data-crossout", "") : s.setAttribute("disabled", ""));
    }
    disableVariantGroup(e) {
        e.querySelectorAll("input").forEach((e) => {
            e.setAttribute("disabled", "");
        });
    }
}
customElements.define("variant-radios", VariantRadios);
class ProductForm extends HTMLElement {
    constructor() {
        super(),
            (this.miniCart = document.querySelector("mini-cart")),
            (this.form = this.querySelector("form")),
            (this.form.querySelector("[name=id]").disabled = !1),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            (this.hideErrors = "true" === this.dataset.hideErrors);
    }
    onSubmitHandler(e) {
        if (document.body.classList.contains("template-cart") || !theme.shopSettings.cartDrawer) return;
        e.preventDefault();
        const t = this.querySelector('[type="submit"]');
        if (t.classList.contains("loading")) return;
        this.handleErrorMessage(), t.setAttribute("aria-disabled", !0), t.classList.add("loading");
        const i = fetchConfig("javascript");
        (i.headers["X-Requested-With"] = "XMLHttpRequest"), delete i.headers["Content-Type"];
        const s = new FormData(this.form);
        this.miniCart &&
            s.append(
                "sections",
                this.miniCart.getSectionsToRender().map((e) => e.id)
            ),
            s.append("sections_url", window.location.pathname),
            (i.body = s),
            fetch(`${theme.routes.cart_add_url}`, i)
                .then((e) => e.json())
                .then((e) => {
                    if (e.status)
                        return (
                            publish(PUB_SUB_EVENTS.cartError, { source: "product-form", productVariantId: s.get("id"), errors: e.errors || e.description, message: e.message }), this.handleErrorMessage(e.description), void (this.error = !0)
                        );
                    this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: s.get("id") }), (this.error = !1), this.miniCart && this.miniCart.renderContents(e);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    t.classList.remove("loading"), t.removeAttribute("aria-disabled");
                });
    }
    handleErrorMessage(e = !1) {
        if (((this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")), this.errorMessageWrapper)) {
            if (this.hideErrors) return;
            (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")), this.errorMessageWrapper.toggleAttribute("hidden", !e), e && (this.errorMessage.textContent = e);
        } else e && alert(e);
    }
}
customElements.define("product-form", ProductForm);
class ProgressBar extends HTMLElement {
    constructor() {
        super(), theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 0 });
    }
    init() {
        setTimeout(() => {
            const e = parseInt(this.dataset.quantity);
            this.style.setProperty("--progress-bar-width", (100 * e) / 30 + "%");
        }, 1e3);
    }
}
customElements.define("progress-bar", ProgressBar);
class FormState extends HTMLElement {
    constructor() {
        super(),
            (this.formInputs = this.querySelectorAll("input,select,textarea")),
            (this.form = this.querySelector("form")),
            this.formInputs.forEach((e) => {
                e.addEventListener("input", this.onInputChange.bind(this)), e.addEventListener("blur", this.onInputChange.bind(this));
            }),
            this.form && this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }
    onInputChange(e) {
        this.handleInputCheck(e.target);
    }
    onSubmitHandler(e) {
        let t = !0;
        this.formInputs.forEach((e) => {
            this.handleInputCheck(e) || (t = !1);
        }),
            t || e.preventDefault();
    }
    handleInputCheck(e) {
        return !e.classList.contains("required") || (0 === e.value.length || e.value === e.dataset.empty ? (e.classList.remove("valid"), e.classList.add("invalid"), !1) : (e.classList.remove("invalid"), e.classList.add("valid"), !0));
    }
}
customElements.define("form-state", FormState);
class ListMenuItem extends HTMLElement {
    constructor() {
        super(),
            (this.listMenuHover = this.closest("menu-drawer").querySelector("list-menu-hover")),
            this.addEventListener("mouseenter", () => {
                this.listMenuHover.open({ title: this.dataset.title, url: this.dataset.url, image: this.dataset.image, description: this.dataset.description });
            });
    }
}
customElements.define("list-menu-item", ListMenuItem);
class ListMenuHover extends HTMLElement {
    constructor() {
        super();
    }
    open(e) {
        let t = "";
        (e.image.length > 0 || e.description.length > 0) &&
            ((t += `<a href="${e.url}" class="hover-collection${e.image.length > 0 ? "" : " hover-collection--no-image"}">`),
            (t += '<figure class="hover-collection__image"' + (e.image.length > 0 ? `style="background-image:url(${e.image})"` : "") + "></figure>"),
            (t += '<div class="hover-collection__content">'),
            (t += `<span class="hover-collection__title h4">${e.title}</span>`),
            (t += e.description.length > 0 ? `<div class="hover-collection__description">${e.description}</div>` : ""),
            (t += "</div>"),
            (t += "</a>")),
            (this.innerHTML = t);
    }
    close() {
        this.innerHTML = "";
    }
}
customElements.define("list-menu-hover", ListMenuHover);
class TransparentHeader extends HTMLElement {
    constructor() {
        super();
        const e = document.querySelector(".shopify-section-header");
        e.classList.add("transparent-header"), "true" == this.dataset.showSeparator && e.classList.add("transparent-separator");
    }
}
customElements.define("transparent-header", TransparentHeader);
class AddToCart extends HTMLElement {
    constructor() {
        super(), (this.miniCart = document.querySelector("mini-cart")), this.addEventListener("click", this.onClickHandler.bind(this));
    }
    onClickHandler() {
        const e = this.dataset.variantId;
        if (e) {
            if (document.body.classList.contains("template-cart") || !theme.shopSettings.cartDrawer) return void Shopify.postLink(theme.routes.cart_add_url, { parameters: { id: e, quantity: 1 } });
            this.setAttribute("disabled", !0), this.classList.add("loading");
            const t = this.miniCart ? this.miniCart.getSectionsToRender().map((e) => e.id) : [],
                i = JSON.stringify({ id: e, quantity: 1, sections: t, sections_url: window.location.pathname });
            fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig("javascript"), body: i })
                .then((e) => e.json())
                .then((e) => {
                    422 === e.status
                        ? document.dispatchEvent(new CustomEvent("ajaxProduct:error", { detail: { errorMessage: e.description } }))
                        : (this.miniCart && this.miniCart.renderContents(e), document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: e } })));
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.classList.remove("loading"), this.removeAttribute("disabled");
                });
        }
    }
}
customElements.define("add-to-cart", AddToCart);
class PriceMoney extends HTMLElement {
    constructor() {
        super(), this.shouldInit() && this.init();
    }
    shouldInit() {
        if (void 0 === document.body.dataset.priceSuperscript) return !1;
        return -1 === theme.shopSettings.moneyFormat.toLowerCase().indexOf("class=");
    }
    init() {
        const e = "ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND".split(","),
            t = theme.shopSettings.moneyFormat.replace(/\{{.*}}/, "").trim(),
            i = this.querySelector("bdi"),
            s = i.textContent.replace(theme.shopSettings.isoCode, "");
        let n = s.replace(" ", ""),
            o = ".";
        if ((e.includes(theme.shopSettings.isoCode) && (o = ","), s.includes(o)))
            if (s.lastIndexOf(t) + t.length === s.length) {
                const e = s.slice(0, s.lastIndexOf(t)),
                    i = s.slice(0, s.lastIndexOf(o)),
                    a = e.replace(i, "").trim();
                n = n.replace(a, `<span class="price__suffix">${a}</span>`);
            } else {
                const e = s.slice(0, s.lastIndexOf(o)),
                    t = s.replace(e, "").trim();
                n = n.replace(t, `<span class="price__suffix">${t}</span>`);
            }
        (n = n.replace(t, `<span class="price__prefix">${t}</span>`)), theme.shopSettings.currencyCode && (n = n + " " + theme.shopSettings.isoCode), (i.innerHTML = n);
    }
}
customElements.define("price-money", PriceMoney);
class SlideshowComponent extends HTMLElement {
    constructor() {
        super(),
            (this.elements = { small: this.querySelector(".slideshow__left"), content: this.querySelector(".slideshow__content"), large: this.querySelector(".slideshow__right") }),
            (this.settings = {
                autorotate: "true" == this.dataset.autorotate,
                autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
                slidesSmall: this.elements.small.querySelectorAll(".slideshow__image"),
                slidesLarge: this.elements.large.querySelectorAll(".slideshow__image"),
            }),
            theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 600 }),
            this.matchMedia();
    }
    init() {
        setTimeout(() => {
            (this.flickitySmall = new Flickity(this.elements.small, {
                accessibility: !1,
                rightToLeft: theme.config.rtl,
                prevNextButtons: !1,
                pageDots: !1,
                wrapAround: !0,
                draggable: !1,
                setGallerySize: !1,
                autoPlay: !!this.settings.autorotate && this.settings.autorotateSpeed,
            })),
                (this.flickityContent = new Flickity(this.elements.content, {
                    accessibility: !1,
                    rightToLeft: theme.config.rtl,
                    prevNextButtons: !0,
                    pageDots: !0,
                    wrapAround: !0,
                    draggable: !!theme.config.mqlSmall,
                    asNavFor: this.elements.small,
                    adaptiveHeight: !0,
                    arrowShape:
                        "M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z",
                    on: {
                        ready: () => {
                            const e = this.querySelectorAll(".flickity-button");
                            e &&
                                e.forEach((e) => {
                                    e.setAttribute("tabindex", "-1");
                                });
                        },
                    },
                })),
                (this.flickityLarge = new Flickity(this.elements.large, {
                    accessibility: !1,
                    rightToLeft: theme.config.rtl,
                    prevNextButtons: !1,
                    pageDots: !1,
                    wrapAround: !0,
                    draggable: !0,
                    setGallerySize: !1,
                    asNavFor: this.elements.content,
                    dragThreshold: 10,
                })),
                this.bindEvents();
        });
    }
    bindEvents() {
        this.flickitySmall.on("scroll", () => {
            this.flickitySmall.slides.forEach((e, t) => {
                const i = this.flickitySmall,
                    s = this.settings.slidesSmall[t];
                let n = 0;
                s &&
                    ((n =
                        0 === t
                            ? Math.abs(i.x) > i.slidesWidth
                                ? i.slidesWidth + i.x + i.slides[i.slides.length - 1].outerWidth + e.target
                                : e.target + i.x
                            : t === i.slides.length - 1 && Math.abs(i.x) + i.slides[t].outerWidth < i.slidesWidth
                            ? e.target - i.slidesWidth + i.x - i.slides[t].outerWidth
                            : e.target + i.x),
                    theme.config.isTouch || theme.config.rtl || (s.style.transform = "translateX(" + -0.5 * n + "px)"));
            });
        }),
            this.flickityLarge.on("scroll", () => {
                this.flickityLarge.slides.forEach((e, t) => {
                    const i = this.flickityLarge,
                        s = this.settings.slidesLarge[t];
                    let n = 0;
                    s &&
                        ((n =
                            0 === t
                                ? Math.abs(i.x) > i.slidesWidth
                                    ? i.slidesWidth + i.x + i.slides[i.slides.length - 1].outerWidth + e.target
                                    : e.target + i.x
                                : t === i.slides.length - 1 && Math.abs(i.x) + i.slides[t].outerWidth < i.slidesWidth
                                ? e.target - i.slidesWidth + i.x - i.slides[t].outerWidth
                                : e.target + i.x),
                        theme.config.isTouch || theme.config.rtl || (s.style.transform = "translateX(" + -0.5 * n + "px)"));
                });
            }),
            this.elements.content.querySelector(".flickity-button.next").addEventListener("click", () => {
                this.flickitySmall && this.flickitySmall.next(), this.stopPlayer();
            }),
            this.elements.content.querySelector(".flickity-button.previous").addEventListener("click", () => {
                this.flickitySmall && this.flickitySmall.previous(), this.stopPlayer();
            }),
            this.elements.content.querySelectorAll(".flickity-page-dot").forEach((e) => {
                e.addEventListener("click", () => {
                    this.stopPlayer();
                });
            });
        let e = null,
            t = null;
        this.flickityLarge.on("dragMove", (i, s, n) => {
            (e = this.flickityLarge.selectedIndex), (t = this.getSwipeDirection(n)), this.stopPlayer();
        }),
            this.flickityLarge.on("dragEnd", () => {
                this.flickityLarge.selectedIndex !== e && ("left" === t ? this.flickitySmall.next() : this.flickitySmall.previous());
            });
    }
    stopPlayer() {
        this.settings.autorotate && this.flickitySmall && this.flickitySmall.stopPlayer();
    }
    getSwipeDirection(e) {
        return e.x > 0 ? "right" : "left";
    }
    matchMedia() {
        document.addEventListener("matchSmall", () => {
            this.unload(), this.init();
        }),
            document.addEventListener("unmatchSmall", () => {
                this.unload(), this.init();
            });
    }
    unload() {
        this.flickitySmall && "function" == typeof this.flickitySmall.destroy && this.flickitySmall.destroy(),
            this.flickityContent && "function" == typeof this.flickityContent.destroy && this.flickityContent.destroy(),
            this.flickityLarge && "function" == typeof this.flickityLarge.destroy && this.flickityLarge.destroy();
    }
}
customElements.define("slideshow-component", SlideshowComponent);
class TestimonialsComponent extends HTMLElement {
    constructor() {
        super(),
            "true" == this.dataset.slider &&
                ((this.settings = { autorotate: "true" == this.dataset.autorotate, autorotateSpeed: parseInt(this.dataset.autorotateSpeed) }),
                (this.slider = this.querySelector(".testimonial__list")),
                (this.previews = this.querySelector(".testimonial__previews")),
                theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 600 }),
                theme.initWhenVisible({ element: this, callback: this.update.bind(this), threshold: 0 }));
    }
    init() {
        setTimeout(() => {
            this.slider &&
                (this.flickity = new Flickity(this.slider, {
                    accessibility: !1,
                    rightToLeft: theme.config.rtl,
                    prevNextButtons: !0,
                    arrowShape:
                        "M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z",
                    pageDots: !1,
                    wrapAround: !0,
                    draggable: !0,
                    cellAlign: "center",
                    autoPlay: !!this.settings.autorotate && this.settings.autorotateSpeed,
                    pauseAutoPlayOnHover: !0,
                    asNavFor: this.previews,
                })),
                (this.flickityNav = new Flickity(this.previews, {
                    accessibility: !1,
                    rightToLeft: theme.config.rtl,
                    prevNextButtons: !this.flickity,
                    arrowShape: this.flickity
                        ? ""
                        : "M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z",
                    pageDots: !1,
                    wrapAround: !0,
                    selectedAttraction: 0.2,
                    friction: 0.8,
                    adaptiveHeight: !0,
                })),
                this.flickityNav.previous(),
                this.settings.autorotate && this.flickity.pausePlayer(),
                this.flickity &&
                    this.flickity.on("staticClick", (e, t, i, s) => {
                        "number" == typeof s && this.flickityNav.select(s);
                    }),
                this.flickity &&
                    this.flickity.on("change", (e) => {
                        this.flickityNav.select(e);
                    });
        });
    }
    update() {
        setTimeout(() => {
            this.flickity && this.flickityNav && (this.flickityNav.next(), this.settings.autorotate && this.flickity.unpausePlayer());
        }, 300);
    }
    getSwipeDirection(e) {
        return e.x > 0 ? "right" : "left";
    }
}
customElements.define("testimonials-component", TestimonialsComponent);
class UseAnimate extends HTMLElement {
    constructor() {
        super(), theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 0 });
    }
    init() {
        this.setAttribute("animate", "");
    }
}
customElements.define("use-animate", UseAnimate);
class AnimateSticky extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.onScrollHandler = this.onScroll.bind(this)), window.addEventListener("scroll", this.onScrollHandler, !1), this.onScrollHandler();
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.onScrollHandler);
    }
    onScroll() {
        (window.pageYOffset || document.documentElement.scrollTop) > this.getOffsetTop(this) ? window.requestAnimationFrame(this.reveal.bind(this)) : window.requestAnimationFrame(this.reset.bind(this));
    }
    reveal() {
        this.setAttribute("animate", "");
    }
    reset() {
        this.removeAttribute("animate");
    }
    getOffsetTop(e) {
        let t = 0;
        for (; e; ) (t += e.offsetTop), (e = e.offsetParent);
        return t;
    }
}
customElements.define("animate-sticky", AnimateSticky);
class LookbookComponent extends HTMLElement {
    constructor() {
        super(), theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 0 });
    }
    init() {
        const e = this.querySelectorAll(".look__hotspot");
        e.forEach((e) => {
            e.classList.add("is-active");
        }),
            setTimeout(() => {
                e.forEach((e) => {
                    e.classList.remove("is-active");
                });
            }, 3e3);
    }
}
customElements.define("lookbook-component", LookbookComponent);
class TabCollage extends HTMLElement {
    constructor() {
        super(),
            this.querySelectorAll(".tab-collage__heading").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this))),
            void 0 === this.dataset.accordion && this.querySelectorAll(".tab-collage__heading").forEach((e) => e.addEventListener("mouseover", this.onButtonClick.bind(this)));
    }
    onButtonClick(e) {
        const t = e.target;
        t.classList.contains("is-active")
            ? void 0 !== this.dataset.accordion && t.classList.remove("is-active")
            : (this.pauseAllMedia(),
              this.querySelectorAll("[data-block-id]").forEach((e) => {
                  t.dataset.blockId === e.dataset.blockId ? e.classList.add("is-active") : e.classList.remove("is-active");
              }));
    }
    pauseAllMedia() {
        this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach((e) => {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        }),
            this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach((e) => {
                e.contentWindow.postMessage('{"method":"pause"}', "*");
            }),
            this.querySelectorAll("video").forEach((e) => e.pause()),
            document.querySelectorAll("video").forEach((e) => e.pause());
    }
}
customElements.define("tab-collage", TabCollage);
class CountdownTimer extends HTMLElement {
    constructor() {
        super(),
            (this.parent = this.closest(".product-countdown")),
            (this.date = new Date(Date.parse(this.dataset.date)).getTime()),
            isNaN(this.date) && ((this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime()), isNaN(this.date)) ? this.unload() : theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 200 });
    }
    init() {
        this.timer(), (this.dataset.interval = setInterval(this.timer.bind(this), 1e3));
    }
    timer() {
        const e = new Date(),
            t = new Date(this.date) - e;
        if (t < 0) return void this.unload();
        const i = 864e5,
            s = 36e5,
            n = Math.floor((t / i) * 1),
            o = Math.floor(((t % i) / s) * 1),
            a = Math.floor((((t % i) % s) / 6e4) * 1),
            r = Math.floor(((((t % i) % s) % 6e4) / 1e3) * 1);
        if ("true" == this.dataset.compact) {
            const e = n > 0 ? `<div class="countdown__item"><span>${n}${theme.dateStrings.d}</span></div>` : "",
                t = `<div class="countdown__item"><span>${o > 9 ? o : "0" + o}:${a > 9 ? a : "0" + a}:${r > 9 ? r : "0" + r}</span></div>`;
            this.innerHTML = e + t;
        } else {
            const e = n > 0 ? `<div class="countdown__item"><span>${n}</span> ${1 == n ? theme.dateStrings.day : theme.dateStrings.days}</div>` : "",
                t = `<div class="countdown__item"><span>${o}</span> ${1 == o ? theme.dateStrings.hour : theme.dateStrings.hours}</div>`,
                i = `<div class="countdown__item"><span>${a}</span> ${1 == a ? theme.dateStrings.minute : theme.dateStrings.minutes}</div>`,
                s = `<div class="countdown__item"><span>${r}</span> ${1 == r ? theme.dateStrings.second : theme.dateStrings.seconds}</div>`;
            this.innerHTML = e + t + i + s;
        }
    }
    unload() {
        this.dataset.interval && clearInterval(this.dataset.interval), this.classList.add("hidden"), this.parent && this.parent.classList.add("hidden");
    }
}
customElements.define("countdown-timer", CountdownTimer);
class GMap extends HTMLElement {
    constructor() {
        super(), this.dataset.apiKey && this.dataset.mapAddress && theme.initWhenVisible({ element: this, callback: this.prepMapApi.bind(this), threshold: 200 });
    }
    prepMapApi() {
        this.loadScript().then(this.initMap.bind(this));
    }
    loadScript() {
        return new Promise((e, t) => {
            const i = document.createElement("script");
            document.body.appendChild(i), (i.onload = e), (i.onerror = t), (i.async = !0), (i.src = "https://maps.googleapis.com/maps/api/js?key=" + this.dataset.apiKey);
        });
    }
    initMap() {
        new google.maps.Geocoder().geocode({ address: this.dataset.mapAddress }, (e, t) => {
            if (t !== google.maps.GeocoderStatus.OK) Shopify.designMode;
            else {
                const t = { zoom: parseInt(this.dataset.zoom), center: e[0].geometry.location, draggable: !0, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                    i = new google.maps.Map(this, t),
                    s = i.getCenter();
                i.setCenter(s);
                const n = {
                    path:
                        "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
                    fillColor: this.dataset.markerColor,
                    fillOpacity: 1,
                    anchor: new google.maps.Point(15, 55),
                    strokeWeight: 0,
                    scale: 0.6,
                };
                new google.maps.Marker({ map: i, position: i.getCenter(), icon: n });
                const o = new google.maps.StyledMapType(JSON.parse(this.parentNode.querySelector("[data-gmap-style]").innerHTML));
                i.mapTypes.set("styled_map", o),
                    i.setMapTypeId("styled_map"),
                    google.maps.event.addDomListener(window, "resize", function () {
                        google.maps.event.trigger(i, "resize"), i.setCenter(s);
                    });
            }
        });
    }
}
customElements.define("g-map", GMap);
class RelatedButtons extends HTMLElement {
    constructor() {
        super(),
            document.querySelector(this.dataset.scrollto)
                ? (window.addEventListener("scroll", this.checkListener.bind(this)), this.querySelectorAll("a").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this))))
                : this.classList.add("hidden");
    }
    checkListener() {
        const e = document.querySelector(this.dataset.scrollto);
        window.scrollY >= e.offsetTop - e.clientHeight ? this.classList.add("is-flipped") : this.classList.remove("is-flipped");
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = e.target;
        document.querySelector(t.getAttribute("href")).scrollIntoView({ behavior: "smooth" });
    }
}
customElements.define("related-buttons", RelatedButtons);
class ProductRecentlyViewed extends HTMLElement {
    constructor() {
        if ((super(), isStorageSupported("local"))) {
            const e = parseInt(this.dataset.productId),
                t = "beyours:recently-viewed",
                i = JSON.parse(window.localStorage.getItem(t) || "[]");
            i.includes(e) || i.unshift(e), window.localStorage.setItem(t, JSON.stringify(i.slice(0, 5)));
        }
    }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);
class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super(), theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 600 });
    }
    init() {
        fetch(this.dataset.url + this.getQueryString())
            .then((e) => e.text())
            .then((e) => {
                const t = document.createElement("div");
                t.innerHTML = e;
                const i = t.querySelector("recently-viewed-products");
                i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML);
            })
            .catch((e) => {
                console.error(e);
            });
    }
    getQueryString() {
        const e = JSON.parse(window.localStorage.getItem("beyours:recently-viewed") || "[]");
        return (
            this.dataset.productId && e.includes(parseInt(this.dataset.productId)) && e.splice(e.indexOf(parseInt(this.dataset.productId)), 1),
            e
                .map((e) => "id:" + e)
                .slice(0, 4)
                .join(" OR ")
        );
    }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);
class VideoSection extends HTMLElement {
    constructor() {
        super(), (this.background = "template" !== this.dataset.initMode), (this.loop = this.dataset.loop), this.background ? theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 600 }) : this.init();
    }
    init() {
        switch (((this.parentSelector = this.dataset.parent || ".media-wrapper"), (this.parent = this.closest(this.parentSelector)), this.dataset.type)) {
            case "youtube":
                this.initYoutubeVideo();
                break;
            case "vimeo":
                this.initVimeoVideo();
                break;
            case "mp4":
                this.initMp4Video();
        }
    }
    initYoutubeVideo() {
        this.setAsLoading(), this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
    }
    initVimeoVideo() {
        this.setAsLoading(), this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
    }
    initMp4Video() {
        const e = this.querySelector("video");
        if (e) {
            const t = e.play();
            void 0 !== t &&
                t
                    .then(function () {})
                    .catch(function () {
                        e.setAttribute("controls", "");
                    });
        }
    }
    loadScript(e) {
        return new Promise((t, i) => {
            const s = document.createElement("script");
            document.body.appendChild(s), (s.onload = t), (s.onerror = i), (s.async = !0), (s.src = "youtube" === e ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js");
        });
    }
    setAsLoading() {
        this.parent.setAttribute("loading", !0);
    }
    setAsLoaded() {
        this.parent.removeAttribute("loading"), this.parent.setAttribute("loaded", !0);
    }
    setupYoutubePlayer() {
        const e = this.dataset.videoId,
            t = setInterval(() => {
                window.YT &&
                    window.YT.ready(() => {
                        const i = document.createElement("div");
                        this.appendChild(i),
                            (this.player = new YT.Player(i, {
                                videoId: e,
                                playerVars: {
                                    showinfo: 0,
                                    controls: !this.background,
                                    fs: !this.background,
                                    rel: 0,
                                    height: "100%",
                                    width: "100%",
                                    iv_load_policy: 3,
                                    html5: 1,
                                    loop: "1" == this.loop ? 1 : 0,
                                    playlist: e,
                                    playsinline: 1,
                                    modestbranding: 1,
                                    disablekb: 1,
                                },
                                events: { onReady: this.onYoutubeReady.bind(this), onStateChange: this.onYoutubeStateChange.bind(this) },
                            })),
                            clearInterval(t);
                    });
            }, 50);
    }
    onYoutubeReady() {
        (this.iframe = this.querySelector("iframe")), this.iframe.setAttribute("tabindex", "-1"), this.background && this.player.mute(), "function" == typeof this.player.playVideo && this.player.playVideo(), this.setAsLoaded();
        new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting ? this.youtubePlay() : this.youtubePause();
                });
            },
            { rootMargin: "0px 0px 50px 0px" }
        ).observe(this.iframe);
    }
    onYoutubeStateChange(e) {
        switch (e.data) {
            case -1:
                this.attemptedToPlay && (this.setAsLoaded(), this.closest(".banner").classList.add("video-interactable"));
                break;
            case 0:
                this.youtubePlay();
                break;
            case 1:
                this.setAsLoaded();
                break;
            case 3:
                this.attemptedToPlay = !0;
        }
    }
    youtubePlay() {
        this.background && this.player && "function" == typeof this.player.playVideo && this.player.playVideo();
    }
    youtubePause() {
        this.background && this.player && "function" == typeof this.player.pauseVideo && this.player.pauseVideo();
    }
    setupVimeoPlayer() {
        const e = this.dataset.videoId,
            t = setInterval(() => {
                window.Vimeo &&
                    ((this.player = new Vimeo.Player(this, { id: e, autoplay: !0, autopause: !1, background: this.background, controls: !this.background, loop: "1" == this.loop, playlist: e, height: "100%", width: "100%" })),
                    this.player.ready().then(this.onVimeoReady.bind(this)),
                    clearInterval(t));
            }, 50);
    }
    onVimeoReady() {
        (this.iframe = this.querySelector("iframe")), this.iframe.setAttribute("tabindex", "-1"), this.background && this.player.setMuted(!0), this.setAsLoaded();
        new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting ? this.vimeoPlay() : this.vimeoPause();
                });
            },
            { rootMargin: "0px 0px 50px 0px" }
        ).observe(this.iframe);
    }
    vimeoPlay() {
        this.background && this.player && "function" == typeof this.player.play && this.player.play();
    }
    vimeoPause() {
        this.background && this.player && "function" == typeof this.player.pause && this.player.pause();
    }
}
customElements.define("video-section", VideoSection);
class BundleProduct extends HTMLElement {
    constructor() {
        super(),
            (this.classes = { souldout: "price--sold-out", onsale: "price--on-sale", nocompare: "price--no-compare" }),
            (this.addToCart = this.querySelector("add-to-cart")),
            (this.price = this.querySelector(".price")),
            (this.variants = this.querySelector("select")),
            this.variants && this.variants.addEventListener("change", this.onSelectChange.bind(this));
    }
    onSelectChange(e) {
        const t = e.target,
            i = t.options[t.selectedIndex],
            s = parseInt(i.dataset.compare_at_price || 0),
            n = parseInt(i.dataset.price || 0),
            o = "true" === i.dataset.available,
            a = "true" === t.dataset.price_varies,
            r = "true" === t.dataset.compare_at_price_varies;
        this.price.classList.remove(this.classes.souldout),
            this.price.classList.remove(this.classes.onsale),
            this.price.classList.remove(this.classes.nocompare),
            !1 === o ? this.price.classList.add(this.classes.souldout) : s > n && o && this.price.classList.add(this.classes.onsale),
            0 == a && r && this.price.classList.add(this.classes.nocompare);
        this.querySelector(".price__regular").querySelector(".price-item--regular").innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(n, theme.shopSettings.moneyFormat)}</bdi></price-money>`;
        const l = this.querySelector(".price__sale");
        (l.querySelector(".price-item--regular").innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(s, theme.shopSettings.moneyFormat)}</bdi></price-money>`),
            (l.querySelector(".price-item--sale").innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(n, theme.shopSettings.moneyFormat)}</bdi></price-money>`),
            this.addToCart && (this.addToCart.dataset.variantId = i.value);
    }
}
customElements.define("bundle-product", BundleProduct);
class BundleProducts extends HTMLElement {
    constructor() {
        super(),
            (this.classes = { hover: "is-hover", active: "is-active" }),
            (this.miniCart = document.querySelector("mini-cart")),
            (this.button = this.querySelector("button")),
            this.button && this.button.addEventListener("click", this.onButtonClick.bind(this)),
            (this.blocks = this.querySelectorAll("[data-block-id]")),
            this.blocks.forEach((e) => e.addEventListener("mouseenter", this.onEnterHandler.bind(this))),
            this.blocks.forEach((e) => e.addEventListener("mouseleave", this.onLeaveHandler.bind(this)));
    }
    onEnterHandler(e) {
        this.classList.add(this.classes.hover);
        const t = e.target,
            i = t.dataset.blockId;
        this.blocks.forEach((e) => {
            "BUNDLE-PRODUCT" !== t.nodeName || "BUNDLE-PRODUCT" !== e.nodeName ? e.dataset.blockId === i && e.classList.add(this.classes.active) : e.classList.add(this.classes.active);
        });
    }
    onLeaveHandler() {
        this.classList.remove(this.classes.hover), this.blocks.forEach((e) => e.classList.remove(this.classes.active));
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = { items: [...this.querySelectorAll('[name="id"]')].map((e) => e.value).map((e) => ({ id: e, quantity: 1 })) };
        if (document.body.classList.contains("template-cart") || !theme.shopSettings.cartDrawer) return void Shopify.postLink2(theme.routes.cart_add_url, { parameters: { ...t } });
        this.handleErrorMessage(), this.button.setAttribute("disabled", !0), this.button.classList.add("loading");
        const i = this.miniCart ? this.miniCart.getSectionsToRender().map((e) => e.id) : [],
            s = JSON.stringify({ ...t, sections: i, sections_url: window.location.pathname });
        fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig("javascript"), body: s })
            .then((e) => e.json())
            .then((e) => {
                e.status
                    ? this.handleErrorMessage(e.description)
                    : 422 === e.status
                    ? document.dispatchEvent(new CustomEvent("ajaxProduct:error", { detail: { errorMessage: e.description } }))
                    : (this.miniCart && this.miniCart.renderContents(e), document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: e } })));
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.button.classList.remove("loading"), this.button.removeAttribute("disabled");
            });
    }
    handleErrorMessage(e = !1) {
        (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
            this.errorMessageWrapper
                ? ((this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")), this.errorMessageWrapper.toggleAttribute("hidden", !e), e && (this.errorMessage.textContent = e))
                : e && alert(e);
    }
}
customElements.define("bundle-products", BundleProducts);
class ShopTheLook extends HTMLElement {
    constructor() {
        super(), 1 != this.dataset.blockCount && theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 600 });
    }
    init() {
        (this.products = this.querySelector(".image-with-text__products")),
            (this.blocks = this.querySelectorAll("lookbook-component [data-block-index]")),
            this.blocks.forEach((e) => e.addEventListener("mouseenter", this.onEnterHandler.bind(this))),
            this.initSlider();
    }
    onEnterHandler(e) {
        if (this.flickity && "function" == typeof this.flickity.select) {
            const t = parseInt(e.target.dataset.blockIndex);
            this.flickity.select(t);
        }
    }
    onFocusHandler(e) {
        this.blocks.forEach((t) => {
            t.classList.remove("focus"), parseInt(t.dataset.blockIndex) === e && t.classList.add("focus");
        });
    }
    initSlider() {
        this.flickity = new Flickity(this.products, {
            accessibility: !1,
            rightToLeft: theme.config.rtl,
            prevNextButtons: !1,
            pageDots: !0,
            wrapAround: !0,
            fade: !0,
            setGallerySize: !0,
            on: {
                ready: () => {
                    this.onFocusHandler(0);
                },
                change: (e) => {
                    this.onFocusHandler(e);
                },
            },
        });
    }
}
customElements.define("shop-the-look", ShopTheLook);
class SelectWrapper extends HTMLElement {
    constructor() {
        super(),
            theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 200 }),
            (this.select = this.querySelector("select")),
            this.select && this.select.addEventListener("change", this.handleSelectChange.bind(this));
    }
    init() {
        const e = window.getComputedStyle(this.select),
            t = this.select.options[this.select.selectedIndex].text,
            i = document.createElement("span");
        (i.style.fontFamily = e.fontFamily), (i.style.fontSize = e.fontSize), (i.style.fontWeight = e.fontWeight), (i.style.visibility = "hidden"), (i.style.position = "absolute"), (i.innerHTML = t), document.body.appendChild(i);
        const s = i.clientWidth;
        this.style.setProperty("--width", `${s}px`), i.remove();
    }
    handleSelectChange() {
        this.init();
    }
}
customElements.define("select-wrapper", SelectWrapper);
class ImageComparison extends HTMLElement {
    constructor() {
        super(),
            (this.active = !1),
            (this.button = this.querySelector("button")),
            (this.horizontal = "horizontal" === this.dataset.layout),
            (this.bodyStyleOverflowY = document.body.style.overflowY),
            this.init(),
            theme.initWhenVisible({ element: this.querySelector(".image-comparison__animate"), callback: this.animate.bind(this), threshold: 0 });
    }
    animate() {
        this.setAttribute("animate", ""),
            this.classList.add("animating"),
            setTimeout(() => {
                this.classList.remove("animating");
            }, 1e3);
    }
    init() {
        this.button.addEventListener("touchstart", this.startHandler.bind(this)),
            document.body.addEventListener("touchend", this.endHandler.bind(this)),
            document.body.addEventListener("touchmove", this.onHandler.bind(this)),
            this.button.addEventListener("mousedown", this.startHandler.bind(this)),
            document.body.addEventListener("mouseup", this.endHandler.bind(this)),
            document.body.addEventListener("mousemove", this.onHandler.bind(this));
    }
    startHandler() {
        window.innerWidth <= 750 && (document.body.style.overflowY = "hidden"), (this.active = !0), this.classList.add("scrolling");
    }
    endHandler() {
        (this.active = !1), this.classList.remove("scrolling"), (document.body.style.overflowY = this.bodyStyleOverflowY);
    }
    onHandler(e) {
        if (!this.active) return;
        const t = (e.touches && e.touches[0]) || e,
            i = this.horizontal ? t.pageX - this.offsetLeft : t.pageY - this.offsetTop;
        this.scrollIt(i);
    }
    scrollIt(e) {
        const t = this.horizontal ? this.clientWidth : this.clientHeight,
            i = t - 20,
            s = (100 * Math.max(20, Math.min(e, i))) / t;
        this.style.setProperty("--percent", s + "%");
    }
}
customElements.define("image-comparison", ImageComparison);
class ScrollingPromotion extends HTMLElement {
    constructor() {
        super(), (this.config = { moveTime: parseFloat(this.dataset.speed), space: 100 }), (this.promotion = this.querySelector(".promotion")), theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 600 });
    }
    init() {
        if (1 === this.childElementCount) {
            this.promotion.classList.add("promotion--animated");
            for (let e = 0; e < 10; e++) {
                (this.clone = this.promotion.cloneNode(!0)), this.clone.setAttribute("aria-hidden", !0), this.appendChild(this.clone);
                const e = this.clone.querySelector(".media-wrapper");
                e && e.classList.remove("loading");
            }
            const e = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
            this.style.setProperty("--duration", `${e}s`);
            new IntersectionObserver(
                (e, t) => {
                    e.forEach((e) => {
                        e.isIntersecting ? this.scrollingPlay() : this.scrollingPause();
                    });
                },
                { rootMargin: "0px 0px 50px 0px" }
            ).observe(this);
        }
    }
    scrollingPlay() {
        this.classList.remove("scrolling-promotion--paused");
    }
    scrollingPause() {
        this.classList.add("scrolling-promotion--paused");
    }
}
customElements.define("scrolling-promotion", ScrollingPromotion);
class AccordionTab extends HTMLElement {
    constructor() {
        super(),
            (this.details = this.querySelector("details")),
            (this.summary = this.querySelector("summary")),
            (this.content = this.querySelector(".accordion__content")),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 200 });
    }
    init() {
        this.summary.addEventListener("click", (e) => this.onClick(e));
    }
    onClick(e) {
        e.preventDefault(), (this.details.style.overflow = "hidden"), this.isClosing || !this.details.open ? this.open() : (this.isExpanding || this.details.open) && this.shrink();
    }
    shrink() {
        this.isClosing = !0;
        const e = window.getComputedStyle(this.summary),
            t = `${this.details.offsetHeight}px`,
            i = `${this.summary.offsetHeight + parseInt(e.marginTop)}px`;
        this.animation && this.animation.cancel(),
            (this.animation = this.details.animate({ height: [t, i] }, { duration: 250, easing: "ease" })),
            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
            (this.animation.oncancel = () => (this.isClosing = !1));
    }
    open() {
        (this.details.style.height = `${this.details.offsetHeight}px`), (this.details.open = !0), window.requestAnimationFrame(() => this.expand());
    }
    expand() {
        this.isExpanding = !0;
        const e = window.getComputedStyle(this.summary),
            t = `${this.details.offsetHeight}px`,
            i = `${this.summary.offsetHeight + parseInt(e.marginTop) + this.content.offsetHeight}px`;
        this.animation && this.animation.cancel(),
            (this.animation = this.details.animate({ height: [t, i] }, { duration: 400, easing: "ease-out" })),
            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
            (this.animation.oncancel = () => (this.isExpanding = !1));
    }
    onAnimationFinish(e) {
        (this.details.open = e), (this.animation = null), (this.isClosing = !1), (this.isExpanding = !1), (this.details.style.height = this.details.style.overflow = "");
    }
}
customElements.define("accordion-tab", AccordionTab);
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: "0px 0px 600px 0px" }).observe(this);
    }
    handleIntersection(e, t) {
        e[0].isIntersecting &&
            (t.unobserve(this),
            fetch(this.dataset.url)
                .then((e) => e.text())
                .then((e) => {
                    const t = document.createElement("div");
                    t.innerHTML = e;
                    const i = t.querySelector("product-recommendations");
                    i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML);
                })
                .catch((e) => {
                    console.error(e);
                }));
    }
}
customElements.define("product-recommendations", ProductRecommendations);
class HeaderMenuToggle extends HTMLElement {
    constructor() {
        super(), (this.header = document.querySelector(".shopify-section-header")), this.addEventListener("click", this.onButtonClick.bind(this));
    }
    onButtonClick() {
        this.header.classList.toggle("shopify-section-header-menu-open");
    }
}
customElements.define("header-menu-toggle", HeaderMenuToggle);
class OptionTable extends HTMLElement {
    constructor() {
        super(),
            (this.config = {}),
            (this.imageOptionRows = this.querySelectorAll(".ot--images .ot--option-row")),
            (this.dataOptionRows = this.querySelectorAll(".ot--data .ot--option-row")),
            theme.initWhenVisible({ element: this, callback: this.init.bind(this), threshold: 600 });
    }
    init() {
        const e = this;
        this.imageOptionRows.forEach((t) => {
            t.addEventListener("mouseenter", function () {
                e.querySelectorAll(".ot--data .ot--option-row").forEach((e) => {
                    e.classList.remove("active");
                }),
                    e.querySelectorAll(".ot--images .ot--option-row").forEach((e) => {
                        e.style.opacity = "0.3";
                    }),
                    e.querySelectorAll(".ot--images .ot--option-row").forEach((e) => {
                        e.style.zIndex = "initial";
                    }),
                    (this.style.opacity = "1"),
                    (this.style.zIndex = "3");
                var t = this.id.replace("imageRow", "dataRow"),
                    i = e.querySelector(`#${t}`);
                i.classList.add("active"),
                    e.querySelectorAll(":scope .data-row.data-headers>div:not(.blank)").forEach((e) => {
                        e.classList.remove("active");
                    }),
                    i.querySelectorAll(":scope div:not(.is-header)").forEach((t, i) => {
                        t.querySelectorAll(":scope svg.checkmark").length > 0 && e.querySelectorAll(":scope .data-row.data-headers>div:not(.blank)")[i].classList.add("active");
                    });
            }),
                t.addEventListener("mouseleave", function () {
                    e.querySelectorAll(".ot--data .ot--option-row").forEach((e) => {
                        e.classList.remove("active");
                    }),
                        e.querySelectorAll(".ot--images .ot--option-row").forEach((e) => {
                            e.style.opacity = "1";
                        }),
                        e.querySelectorAll(":scope .data-row.data-headers>div:not(.blank)").forEach((e) => {
                            e.classList.remove("active");
                        });
                });
        }),
            this.dataOptionRows.forEach((t) => {
                t.addEventListener("mouseenter", function () {
                    e.querySelectorAll(".ot--data .ot--option-row").forEach((e) => {
                        e.classList.remove("active");
                    }),
                        this.classList.add("active"),
                        e.querySelectorAll(".ot--images .ot--option-row").forEach((e) => {
                            e.style.opacity = "0.3";
                        }),
                        e.querySelectorAll(".ot--images .ot--option-row").forEach((e) => {
                            e.style.zIndex = "initial";
                        });
                    var t = this.id.replace("dataRow", "imageRow");
                    (e.querySelector(`#${t}`).style.opacity = "1"), (e.querySelector(`#${t}`).style.zIndex = "3");
                }),
                    t.addEventListener("mouseleave", function () {
                        e.querySelectorAll(".ot--data .ot--option-row").forEach((e) => {
                            e.classList.remove("active");
                        }),
                            e.querySelectorAll(".ot--images .ot--option-row").forEach((e) => {
                                e.style.opacity = "1";
                            }),
                            e.querySelectorAll(":scope .data-row.data-headers>div:not(.blank)").forEach((e) => {
                                e.classList.remove("active");
                            });
                    });
            });
    }
}
customElements.define("option-table", OptionTable);
class LocalizationForm extends HTMLElement {
    constructor() {
        super(),
            (this.elements = { input: this.querySelector('input[name="locale_code"], input[name="country_code"]'), button: this.querySelector("button"), panel: this.querySelector("ul") }),
            this.elements.button.addEventListener("click", this.openSelector.bind(this)),
            this.elements.button.addEventListener("focusout", this.closeSelector.bind(this)),
            this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
            this.querySelectorAll("a").forEach((e) => e.addEventListener("click", this.onItemClick.bind(this)));
    }
    hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false"), this.elements.panel.setAttribute("hidden", !0), this.classList.contains("on-header") && document.body.classList.remove("localization--open");
    }
    onContainerKeyUp(e) {
        "ESCAPE" === e.code.toUpperCase() && this.hidePanel();
    }
    onItemClick(e) {
        e.preventDefault();
        const t = this.querySelector("form");
        (this.elements.input.value = e.currentTarget.dataset.value), t && t.submit();
    }
    openSelector() {
        this.elements.panel.toggleAttribute("hidden"),
            this.elements.button.setAttribute("aria-expanded", ("false" === this.elements.button.getAttribute("aria-expanded")).toString()),
            this.classList.contains("on-header") && document.body.classList.toggle("localization--open");
    }
    closeSelector(e) {
        const t = e.relatedTarget && "BUTTON" === e.relatedTarget.nodeName;
        (null === e.relatedTarget || t) && this.hidePanel();
    }
}
customElements.define("localization-form", LocalizationForm);
